import { createSlice } from "@reduxjs/toolkit";

const storePagesSlice = createSlice({
  name: "storePages",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {
    setStorePagesLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setStorePages(state, action) {
      state.items = action.payload;
      state.loading = false;
      state.error = null;
    },
    setStorePagesError(state, action) {
      state.loading = false;
      state.error = action.payload;
    }
  },
});

export const { 
  setStorePagesLoading, 
  setStorePages, 
  setStorePagesError 
} = storePagesSlice.actions;

export default storePagesSlice.reducer;